<template>
    <div class="com-famous-comment-item-web">
        <div class="com-famous-comment-item-web-all dsp-flex">
            <div class="com-famous-ci-avatar">
                <img class="com-famous-ci-img" v-bind:src="itemData.userAvatar == '' ? avatarUrl : itemData.userAvatar" alt="">
            </div>
            <div class="com-famous-ci-content">
                <div class="com-famous-cic-title">
                    <span class="com-famous-cic-nickname">{{itemData.userName}}</span>
                    <span v-if="!itemData.isDelete" class="com-famous-cic-more" @click="clickMore">
                        <i class="iconfont icon-more"></i>
                    </span>
                </div>
                <div class="layout-overlay layout-overlay-blank" v-if="showOperate" @click="clickBlankOverlay"></div>
                <div class="com-famous-operate-pop" v-if="showOperate">
                    <div class="famous-crl-item" v-if="curCommentMoreFromMe" @click="clickDelete">删除</div>
                    <div class="famous-crl-item" v-else @click="clickReport">举报</div>
                </div>
                <div v-if="itemData.isDelete" class="com-famous-cic-content-delete">
                    <p>该评论已删除</p>
                </div>
                <div v-else class="com-famous-cic-content">
                    <p v-html="UTILS.getBreakLineByText(itemData.msg)"></p>
                </div>
                <div class="com-famous-cic-sub">
                    <span v-if="!itemData.isDelete" class="com-famous-cic-good-2" @click.passive="clickLike">
                        <i class="iconfont" v-bind:class="{'icon-good2':itemData.isLike == 1, 'icon-good3':itemData.isLike == 0}"></i>赞<span v-if="itemData.likeNum != 0" class="com-famous-cic-good-num">{{itemData.likeNum}}</span>
                    </span>
                    <span v-if="!itemData.isDelete" class="com-famous-cic-comment" @click="clickReply">
                        <i class="iconfont icon-comment-1"></i>回复
                    </span>
                </div>
            </div>
        </div>
        <div v-if="!itemData.isDelete && allSecondList && allSecondList.length > 0" class="com-famous-cic-second-list">
            <famous-comment-item-web
                v-for="secondData in allSecondList"
                v-bind:key="secondData.key+secondData.id"
                v-bind:itemData="secondData"
                v-bind:operateFunc="operateFunc">
            </famous-comment-item-web>
        </div>
        <span class="com-famous-cic-note com-famous-cic-note-second" v-if="showReplyText != ''" @click="clickCheckReply">{{showReplyText}}</span>
    </div>
</template>

<script>
import { UTILS } from '../../modules/utils'
import FamousCommentItemWeb from './FamousCommentItemWeb.vue'
export default {
    name: 'FamousCommentItemAllWeb',
    components: { FamousCommentItemWeb },
    computed: {
        curCommentMoreFromMe() {
            return this.$store.state.famouspediacomment.curCommentMoreFromMe;
        }
    },
    props: {
        itemData: {
            type: Object,
            default() { return {} }
        },
        secondList: {
            type: Object,
            default() { return {} }
        },
        operateFunc: {
            type: Function,
            default() { return null }
        }
    },
    data() {
        return {
            UTILS: UTILS,
            avatarUrl: require('../../assets/images/avatar.png'),
            showOperate: false,
            showAllSecondList: false,
            allSecondList: [],
            showReplyText: ''
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initData();
        }, 20);
        this.$bus.on('updateSecondList', this.initData)
    },
    destroyed() {
        this.$bus.off('updateSecondList', this.initData)
    },
    methods: {
        clickCheckReply() {
            this.showAllSecondList = !this.showAllSecondList;
            this.initData();
        },
        initData() {
            console.error('initData-------', this.itemData)
            var list = this.secondList && this.secondList[this.itemData.id] ? this.secondList[this.itemData.id] : [];
            // 处理列表数据
            if(this.showAllSecondList) {
                this.allSecondList = list
            }else {
                this.allSecondList = list.length >= 2 ? _.concat(list[0], list[1]) : list;
            }
            // 处理文本
            if(list.length > 2) {
                this.showReplyText = this.showAllSecondList ? '收起回复' : '展开其他' + (list.length - 2) + '条回复' ;
            }else {
                this.showReplyText = '';
            }
        },
        clickMore() {
            var userData = this.$store.state.userData;
                userData = userData && userData.info ? userData.info : {};
            
            var me = this;
            this.$store.dispatch('weblogin/checkWebLogin', {
                sucCb: function() {
                    me.$store.dispatch('famouspediacomment/initCommentAllListMore', {
                        data: me.itemData,
                        userData: userData
                    });
                    me.showOperate = true;
                }
            });
        },
        clickLike() {
            var me = this;
            this.$store.dispatch('weblogin/checkWebLogin', {
                sucCb: function() {
                    if(me.operateFunc && typeof(me.operateFunc) == 'function') {
                        me.operateFunc('like', me.itemData)
                    }
                }
            });
        },
        clickReply() {
            var me = this;
            this.$store.dispatch('weblogin/checkWebLogin', {
                sucCb: function() {
                    if(me.operateFunc && typeof(me.operateFunc) == 'function') {
                        me.operateFunc('reply', me.itemData)
                    }
                }
            });
        },
        clickBlankOverlay() {
            this.showOperate = false;
        },
        clickDelete() {
            var me = this;
            this.$store.dispatch('famouspediacomment/deleteComment', {
                cb: function() {
                    me.$toast('删除评论成功');
                },
                failCb: function() {
                    me.$toast('删除评论失败');
                }
            });
        },
        clickReport() {
            var userData = this.$store.state.userData;
                userData = userData && userData.info ? userData.info : {};
            this.$store.dispatch('famouspediacomment/initCommentAllListMore', {
                data: this.itemData,
                userData: userData
            });
            this.$store.state.weblogin.showWebReport = true;
        },
    }
}
</script>